import { useDispatch } from 'react-redux'

import { runtimeConfig } from '@app/common/config'
import { useScript } from '@app/hooks/useScript'
import { setCtmNumberReady } from '@app/store/ui'

const CTM_ADDITIONAL_CALL_DELAY = 100
const TRACKING_ID = runtimeConfig?.joinSproutTherapyConfig?.CTM_ID

export const CTMScript = () => {
  const status = useScript(`//${TRACKING_ID}.tctm.co/t.js`)
  const dispatch = useDispatch()

  if (status === 'ready') {
    // safety net call
    // most probably we don't need this, but keep it for now
    setTimeout(() => {
      window && window.__ctm?.main?.runNow()
      dispatch(setCtmNumberReady())
    }, CTM_ADDITIONAL_CALL_DELAY)
  } else if (status === 'error') {
    // show whatever number we have
    dispatch(setCtmNumberReady())
  }

  return null
}
